import { resolvePartyFilter } from './mapPartyParams.js';

/**
 * Effective party name for the active request.
 * URL presence wins. Otherwise the saved name applies when it is in today's options.
 */
export const resolveRequestPartyFilter = ({
  urlField,
  savedValue,
  options,
  isFetched = false,
}) => {
  if (urlField?.present) return urlField.value || '';
  return resolvePartyFilter(
    { present: false, value: '' },
    isFetched ? savedValue : '',
    options,
  );
};
